// extracted by mini-css-extract-plugin
module.exports = {"accord_child":"AccordionContainer__accord_child__siTPN","accord_anim":"AccordionContainer__accord_anim__M9ftm"};